<div class='card'>
    <div class='card-header'>
        <h5>Please Choose Organisation to login with</h5>
    </div>
    <!-- TODO change this component it wont work here. Look at searchAccounts and select accounts -->
    <ul class='list-group'>
        <li class='list-group-item' *ngFor='let organization of organizations; index as i'
            (click)='organizationSelected(i)'>
            {{organization.name}}
        </li>
    </ul>
</div>
